import { render, staticRenderFns } from "./ProFolderEditModal.vue?vue&type=template&id=005d8c50&"
import script from "./ProFolderEditModal.vue?vue&type=script&lang=ts&"
export * from "./ProFolderEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports